//
//
//
//


export default {

    props: {
        stars: {

        }
    },

    computed: {

        getStars() {

            var $html = '';
            var $i;

            for($i = 1; $i <= 5; $i += 0.5) {

                if(Math.floor($i) == $i) {

                    if(this.stars > $i) {
                        $html += '<i class="fas fa-star star-checked"></i>';
                    } else if (this.stars < $i) {
                        $html += '<i class="fas fa-star star-not-checked"></i>';
                    }

                } else {

                    if(this.stars == $i && Math.floor($i) != $i) {
                        $html += '<i class="fas fa-star-half-alt star-checked"></i>';
                        $i += 0.5;
                    }

                }
            }

            return $html;

        },

    },

}

